import styled from "styled-components/macro";

export const ButtonContainer = styled.div`
width: 100%; 
margin-left: 145px;
@media (min-width: 1200px) {
    width: fit-content; 
    margin: 0;
}
`